import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, addDoc, serverTimestamp, doc, onSnapshot, query, where } from 'firebase/firestore';

const Wallet = ({ onBack }) => {
    const [view, setView] = useState('withdraw');
    const [amount, setAmount] = useState('');
    const [accountName, setAccountName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [method, setMethod] = useState('Kpay');
    const [screenshot, setScreenshot] = useState(null);
    const [loading, setLoading] = useState(false);
    const [userPoints, setUserPoints] = useState(0);
    const [history, setHistory] = useState([]);
    const [isPending, setIsPending] = useState(false); // 🟢 State နဲ့ သေချာထိန်းမယ်

    useEffect(() => {
        if (auth.currentUser) {
            // 1. User Balance ကို နားထောင်ခြင်း
            const unsubPoints = onSnapshot(doc(db, "users", auth.currentUser.uid), (doc) => {
                if (doc.exists()) setUserPoints(doc.data().points || 0);
            });

            // 2. History နဲ့ Pending Status ကို နားထောင်ခြင်း
            // Index Error မတက်အောင် orderBy ကို ခဏဖြုတ်ထားပြီး JS ဘက်မှာ Sort လုပ်ပါမယ်
            const q = query(
                collection(db, "wallet_requests"),
                where("userId", "==", auth.currentUser.uid)
            );

            const unsubHistory = onSnapshot(q, (snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                
                // JS ဘက်မှာ အချိန်အလိုက် ပြန်စီမယ်
                const sortedData = data.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
                setHistory(sortedData);

                // Pending ရှိမရှိ စစ်မယ်
                const pendingExists = data.some(item => item.status === 'pending');
                setIsPending(pendingExists);
            });

            return () => { unsubPoints(); unsubHistory(); };
        }
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setScreenshot(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async () => {
        if (isPending) return alert("Pending order ရှိနေသေးသဖြင့် ထပ်မံတောင်းဆို၍ မရနိုင်သေးပါ။");

        const numAmount = Number(amount);
        if (!amount || !phoneNumber || !accountName) return alert("အချက်အလက်အားလုံး ဖြည့်စွက်ပါ!");
        if (numAmount < 5000) return alert("အနည်းဆုံး 5,000 MMK မှ စတင်လုပ်ဆောင်နိုင်ပါသည်။");
        if (view === 'withdraw' && numAmount > userPoints) return alert("လက်ကျန် Points မလုံလောက်ပါ။");
        if (view === 'deposit' && !screenshot) return alert("ငွေလွှဲ screenshot တင်ပေးရန် လိုအပ်ပါသည်။");

        setLoading(true);
        try {
            await addDoc(collection(db, "wallet_requests"), {
                userId: auth.currentUser.uid,
                userEmail: auth.currentUser.email,
                type: view,
                amount: numAmount,
                paymentMethod: method,
                accountName: accountName,
                phoneNumber: phoneNumber,
                screenshot: screenshot || null,
                status: 'pending',
                createdAt: serverTimestamp()
            });
            
            alert(`အောင်မြင်ပါသည်။ Admin မှ စစ်ဆေးပေးပါမည်။`);
            setAmount(''); setAccountName(''); setPhoneNumber(''); setScreenshot(null);
            setView('history');
        } catch (err) { alert("Error: " + err.message); }
        setLoading(false);
    };

    return (
        <div className="wallet-container" style={{paddingBottom: '40px', background: '#fff', minHeight: '100vh'}}>
            <div style={headerStyle}>
                <span className="material-icons-round" onClick={onBack} style={{cursor: 'pointer'}}>arrow_back</span>
                <h3 style={{marginLeft: '15px'}}>My Wallet</h3>
            </div>

            <div style={balanceCard}>
                <span style={{fontSize: '13px', opacity: 0.8}}>Available Points</span>
                <h1 style={{margin: '5px 0 0', color: '#e5b95f', fontSize: '32px'}}>{userPoints.toLocaleString()}</h1>
            </div>

            <div style={tabContainer}>
                <button onClick={() => setView('withdraw')} style={toggleBtn(view === 'withdraw')}>Withdraw</button>
                <button onClick={() => setView('deposit')} style={toggleBtn(view === 'deposit')}>Deposit</button>
                <button onClick={() => setView('history')} style={toggleBtn(view === 'history')}>History</button>
            </div>

            <div style={contentArea}>
                {view === 'history' ? (
                    history.length === 0 ? <p style={{textAlign:'center', marginTop: '20px'}}>No history found.</p> :
                    history.map(item => (
                        <div key={item.id} style={historyCard}>
                            <div>
                                <b style={{color: item.type === 'deposit' ? '#2ecc71' : '#e74c3c'}}>{item.type.toUpperCase()}</b>
                                <div style={{fontSize:'11px', color:'#999'}}>{item.createdAt?.toDate().toLocaleDateString()}</div>
                            </div>
                            <div style={{textAlign: 'right'}}>
                                <b>{item.amount.toLocaleString()} MMK</b>
                                <div style={{fontSize:'12px', color: item.status === 'approved' ? '#2ecc71' : '#f39c12'}}>{item.status}</div>
                            </div>
                        </div>
                    ))
                ) : (
                    /* 🟢 Form logic with Pending Overlay */
                    <div style={{position: 'relative'}}>
                        {isPending && (
                            <div style={overlayStyle}>
                                <span className="material-icons-round" style={{fontSize: '40px', color: '#f39c12'}}>lock</span>
                                <p style={{fontWeight: 'bold'}}>Request Locked</p>
                                <p style={{fontSize: '12px'}}>Pending အဟောင်းရှိနေသဖြင့် အသစ်တင်၍မရပါ။</p>
                            </div>
                        )}
                        
                        <div style={{opacity: isPending ? 0.3 : 1, pointerEvents: isPending ? 'none' : 'auto'}}>
                            {view === 'deposit' && (
                                <div style={adminAccountBox}>
                                    <p><b>Admin Kpay:</b>Aung Hein Htet 09 756 986 331</p>
                                </div>
                            )}
                            <input type="text" placeholder="Account Name" value={accountName} onChange={(e) => setAccountName(e.target.value)} style={inputStyle} />
                            <select value={method} onChange={(e) => setMethod(e.target.value)} style={inputStyle}>
                                <option value="Kpay">Kpay</option>
                                <option value="WaveMoney">WaveMoney</option>
                            </select>
                            <input type="number" placeholder="Phone Number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} style={inputStyle} />
                            <input type="number" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} style={inputStyle} />

                            {view === 'deposit' && (
                                <div style={uploadBox} onClick={() => document.getElementById('file-up').click()}>
                                    <input id="file-up" type="file" accept="image/*" onChange={handleFileChange} style={{display:'none'}} />
                                    {screenshot ? <img src={screenshot} style={{width:'100%', borderRadius:'10px'}} /> : "Upload Screenshot"}
                                </div>
                            )}
                            <button onClick={handleSubmit} disabled={loading} style={submitBtn}>
                                {loading ? "Processing..." : `Submit ${view}`}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// --- Styles ---
const headerStyle = { display: 'flex', alignItems: 'center', padding: '20px' };
const balanceCard = { margin: '0 20px 20px', padding: '25px', background: '#1a1a1a', borderRadius: '20px', textAlign: 'center', color: '#fff' };
const tabContainer = { display: 'flex', gap: '10px', padding: '0 20px 20px' };
const toggleBtn = (active) => ({ flex: 1, padding: '12px', borderRadius: '12px', border: 'none', background: active ? '#1a1a1a' : '#f0f0f0', color: active ? '#fff' : '#666', fontWeight: 'bold' });
const contentArea = { margin: '0 20px', padding: '20px', background: '#f9f9f9', borderRadius: '25px' };
const inputStyle = { width: '100%', padding: '14px', marginBottom: '10px', borderRadius: '10px', border: '1px solid #eee' };
const historyCard = { background: '#fff', padding: '12px', borderRadius: '12px', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', border: '1px solid #f0f0f0' };
const adminAccountBox = { background: '#fffcf5', padding: '10px', borderRadius: '10px', marginBottom: '10px', border: '1px dashed #c28b20', textAlign:'center' };
const uploadBox = { border: '2px dashed #ddd', padding: '20px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px', cursor: 'pointer' };
const submitBtn = { width: '100%', padding: '15px', borderRadius: '10px', border: 'none', background: '#1a1a1a', color: '#fff', fontWeight: 'bold' };
const overlayStyle = { position: 'absolute', top:0, left:0, right:0, bottom:0, background: 'rgba(255,255,255,0.7)', zIndex: 10, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' };

export default Wallet;